export const UPDATE_DATA = "UPDATE_DATA";
export const UPDATE_DATA_LOADING = "UPDATE_DATA_LOADING";
export const UPDATE_ADDITIONAL_CONDITIONS = "UPDATE_ADDITIONAL_CONDITIONS";
export const UPDATE_ADDITIONAL_CONDITIONS_LOADING =
	"UPDATE_ADDITIONAL_CONDITIONS_LOADING";
